/*
 * Copyright (c) 2024 Helvia Technologies PC <contact@helvia.io>
 */

import { useEffect, useMemo, useState } from 'react';
import { getOidcInfoForStartingAuthorization } from '../../oidc';
import { useLocation } from 'react-router-dom';

/**
 * React hook that provides information for starting an OIDC authorization.
 * @returns
 */
export const useOidcRequest = ({ integration, organizationId, options } = {}) => {
  const [info, setInfo] = useState({});
  const location = useLocation();

  const variables = useMemo(() => {
    if (!location.search) {
      return null;
    }
    const urlSearchParams = new URLSearchParams(location.search);
    const _variables = Object.fromEntries(urlSearchParams.entries());
    if (_variables.orgId) {
      delete _variables.orgId;
    }
    return Object.keys(_variables).length > 0 ? _variables : null;
  }, [location]);

  useEffect(() => {
    const updateState = async () => {
      const info = await getOidcInfoForStartingAuthorization({ integration, organizationId, variables, options });
      setInfo(info);
    };

    updateState();
  }, [integration, organizationId, options, variables]);

  return {
    oidcConfiguration: info.oidcConfiguration || null,
    oidcRequest: info.oidcRequest || null,
    oidcAuthorizationUrl: info.oidcAuthorizationUrl || null,
    oidcCodeVerifier: info.oidcCodeVerifier || null,
    oidcRedirectUrl: info.oidcRedirectUrl || null,
    oidcVariables: variables || null
  };
};
